<app-loading *ngIf="viewModel.isLoading$ | async" [options]="viewModel?.loadingOpts$ | async"> </app-loading>

<lib-reactive-form-merge-groups
  #dateTimeModalForms
  [mergeKey]="viewModel.mergeKey$ | push"
  (canSubmit$)="viewModel.connectToCanSubmit($event)"
  (unsavedChanges$)="viewModel.connectToUnsavedChanges($event)"
  (formsSubmitted$)="viewModel.saveDateTimeInformation()"></lib-reactive-form-merge-groups>

<lib-sticky-modal>
  <lib-sticky-header>
    <div class="modal-header">
      <div class="modal-title">Edit Specific Date/Time</div>
      <div>{{ viewModel.menuName$ | push }}</div>
    </div>
  </lib-sticky-header>
  <lib-sticky-body [placeInSameZPlaneAsHeaderAndFooter]="true">
    <div class="mt-16px date-time-windows-container">
      <div>
        <div class="bs-bold f18px">Date/Time Windows</div>
        <div class="bs-regular f14px">
          Select date and time windows when the menu should appear on the display. By default the menu will always
          appear based on the recurring details.
        </div>
      </div>
      <div class="mt-16px mb-16px">
        <ng-container *rxFor="let dateTimeWindow of viewModel.dateTimeWindows$ | push; let i = index">
          <app-date-time-window-form
            [bindTo]="dateTimeWindow"
            [mergeKey]="viewModel.mergeKey$ | push"
            [index]="i"
            (removeDateTimeWindow)="viewModel.removeDateTimeWindow($event)"></app-date-time-window-form>
        </ng-container>
        <lib-button-neutral
          [iconSrc]="'assets/icons/dark/outline/plus.svg'"
          (buttonClicked)="viewModel.addDateTimeWindow()">
          Add Date / Time Window
        </lib-button-neutral>
      </div>
    </div>

    <div class="mt-24px recurring-details-container">
      <app-recurring-details-form
        [recurringDetails]="viewModel.recurringDetails$ | push"
        [mergeKey]="viewModel.mergeKey$ | push">
      </app-recurring-details-form>
    </div>
  </lib-sticky-body>
  <lib-sticky-footer>
    <lib-button-layout>
      <lib-button-neutral (buttonClicked)="cancel()"> Cancel </lib-button-neutral>
      <lib-button-primary [disabled]="!(viewModel.canSave$ | push)" (buttonClicked)="dateTimeModalForms.submitForms()">
        Done
      </lib-button-primary>
    </lib-button-layout>
  </lib-sticky-footer>
</lib-sticky-modal>
